/*
 * Copyright (c) 2020  Apricad LLC. All Rights Reserved.
 */

import { niceScrollbar } from "assets/jss/views/classroomPage/classroomStyle";

const mainImg = require("assets/img/desk3.jpg");
export const pageBackground = {
  "@media (min-width: 768px)": {
    backgroundImage: `url(${mainImg})`,
    backgroundSize: "cover",
  },
  height: "100vh",
  width: "100%",
};

export const container = {
  position: "relative",
  "@media (min-width: 768px)": {
    width: "95vw",
    height: "90vh",
    padding: "1.5rem 0",
    top: "calc(5vh + 27px)",
    margin: "auto",
    borderRadius: "6px",
    border: "1px solid gray",
    boxShadow:
      "0 16px 24px 2px rgba(0, 0, 0, 0.14), 0 6px 30px 5px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2);",
  },
  "@media (min-width: 1280px)": {
    width: "80vw",
    padding: "1.5rem",
  },
  width: "100%",
  height: "100%",
};

export const contentBox = {
  "@media (min-width: 768px)": {
    width: "90%",
    margin: "auto",
    padding: "1rem",
  },
  padding: "5rem 1rem 0",
  maxHeight: "100%",
  width: "100%",
  overflow: "auto",
};

export const title = {
  fontSize: "2.5rem",
  fontWeight: "300",
  marginBottom: "1.5rem",
};

const contentFont = {
  "& ul li": {
    fontSize: "0.9rem",
  },
};

const styles = (theme) => {
  return {
    "@global": niceScrollbar,

    tabs: {
      borderRight: `2px solid ${theme.palette.divider}`,
    },

    pageBackground,
    container: {
      ...container,
      backgroundColor: theme.palette.paper.light,
    },
    contentBox,
    title,

    content: {
      width: "100%",
      ...contentFont,
      "& h1": {
        fontSize: "1.5rem",
        fontWeight: "400",
        marginTop: "1rem",
        marginBottom: "0.6rem",
        paddingBottom: "0.25rem",
        borderBottom: `2px solid ${theme.palette.primary.dark}`,
      },
      "& h2": {
        fontSize: "1.2rem",
        fontWeight: "600",
        color: "#3C4858",
        marginTop: "1rem",
        marginBottom: "0.3rem",
      },
    },

    ending: {
      color: theme.palette.secondary.main,
      fontSize: "150%",
      width: "1.5rem",
      margin: "auto",
      position: "relative",
    },
  };
};

export default styles;
